import {
  AssignUserRoleRequest,
  CancelInvitationRequest,
  InvitationRequest,
  UserFull,
  UserCredentials,
  UserContact,
  UserInvitation,
  CompanyUser,
  CompanyRole,
  ResSavedFilter,
  ReqSavedFilter,
} from '@/models/users'
import api from './api'

class UserApiService {
  static getInstance(): UserApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: UserApiService

  private baseUrl = '/users'

  private constructor() {
    // empty for linter
  }

  assignRole(payload: AssignUserRoleRequest) {
    const url = `${this.baseUrl}/${payload.user}/role?id=${payload.role}`
    return api.put<boolean>(url)
  }

  cancelInvitation(payload: CancelInvitationRequest, company: string) {
    const url = `/companies/${company}/invitations/cancel`
    return api.post<boolean>(url, payload)
  }

  invite(payload: InvitationRequest) {
    const url = `${this.baseUrl}/invite`
    return api.post<boolean>(url, payload)
  }

  getCurrentUser() {
    const url = `${this.baseUrl}/me?expand=roles,contacts,script,company,carrot_key`
    return api.get<UserFull>(url)
  }

  updateCurrentUser(payload: UserContact) {
    const url = `${this.baseUrl}/me`
    return api.post<boolean>(url, payload)
  }

  updateCurrentUserLanguage(language: string) {
    const url = `${this.baseUrl}/me/language?code=${language}`
    return api.put<boolean>(url)
  }

  changePassword(payload: UserCredentials) {
    const url = `${this.baseUrl}/me/password`
    return api.post<boolean>(url, payload)
  }

  delete(id: string) {
    const url = `${this.baseUrl}/${id}`
    return api.delete<boolean>(url)
  }

  getCompanyUsers(companyId: string) {
    const url = `/companies/${companyId}/users?expand=email,fname,lname`
    return api.get<CompanyUser[]>(url)
  }

  getCompanyInvitations(companyId: string) {
    const url = `/companies/${companyId}/invitations`
    return api.get<UserInvitation[]>(url)
  }

  getCompanyRoles(companyId: string) {
    const url = `/companies/${companyId}/roles`
    return api.get<CompanyRole[]>(url)
  }

  getAllSavedFilters(sectionName: string) {
    const url = `users/me/filters?section=${sectionName}`
    return api.get<ResSavedFilter[]>(url)
  }

  getSavedFilter(id: number) {
    const url = `${this.baseUrl}/me/filters/${id}`
    return api.get<ResSavedFilter>(url)
  }

  setSavedFilter(payload: ReqSavedFilter) {
    const url = `${this.baseUrl}/me/filters`
    return api.post<ResSavedFilter>(url, payload)
  }

  updateSavedFilter(payload: ResSavedFilter) {
    const url = `${this.baseUrl}/me/filters${payload.id}`
    return api.post<ResSavedFilter>(url, {
      title: payload.title,
      query: payload.query,
    })
  }

  deleteSavedFilter(id: number) {
    const url = `${this.baseUrl}/me/filters/${id}`
    return api.delete<boolean>(url)
  }
}

export default UserApiService.getInstance()
